/**
 * Mapbox `bearing` is clockwise degrees from north. The arrow is rotated by `-bearing` so the
 * tip aligns with geographic north on the map.
 */
export function buildPermittingNorthArrowInnerHtml(bearingDeg: number): string {
  const rot = -bearingDeg;
  return `<div class="permitting-north-arrow-rotate" style="transform:rotate(${rot}deg);transform-origin:50% 50%">
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 28 34" aria-hidden="true" focusable="false">
    <path d="M14 3 L24 22 L14 17 L4 22 Z" fill="#243442" stroke="#fff" stroke-width="1" stroke-linejoin="round"/>
    <text x="14" y="31" text-anchor="middle" font-size="11" font-weight="600" font-family="Noto Sans,system-ui,sans-serif" fill="#243442">N</text>
  </svg>
</div>`;
}
